import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Loader2, Ticket } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    // PayPal redirects back with paymentId and PayerID in URL
    const paymentId = searchParams.get('paymentId');
    const payerId = searchParams.get('PayerID');
    
    if (paymentId && payerId) {
      // The actual payment execution happens on the event detail page
      // This is just a success confirmation page
      setProcessing(false);
    } else {
      setProcessing(false);
    }
  }, [searchParams]);

  if (processing) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto mb-4" />
          <p className="text-muted-foreground">Processing your payment...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center py-12">
      <div className="max-w-md mx-auto px-4 text-center">
        <div className="w-20 h-20 rounded-full bg-green-500/20 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-green-500" />
        </div>
        
        <h1 className="font-heading font-bold text-3xl mb-4">Payment Successful!</h1>
        <p className="text-muted-foreground mb-8">
          Thank you for your purchase! Your tickets have been added to your account.
        </p>
        
        <div className="space-y-3">
          <Button className="w-full gap-2" onClick={() => navigate('/my-tickets')}>
            <Ticket className="w-4 h-4" />
            View My Tickets
          </Button>
          <Button variant="outline" className="w-full" onClick={() => navigate('/events')}>
            Browse More Events
          </Button>
        </div>
      </div>
    </div>
  );
}
